@if (footerData$ | async; as footerData) {
  <div class="section" [class.dark]="dark" [class.black]="black">
    <div class="page">
      @if (!simpleMode) {
        @if (footerMenu$ | async; as footerMenu) {
          <div class="footer-menu">
            @for (menuGroup of footerMenu; track menuGroup) {
              <div class="footer-menu-list">
                @for (menu of menuGroup; track menu) {
                  <div class="footer-menu-list-title">{{ menu.title }}</div>
                  @for (item of menu.items; track item.link) {
                    @if (item.isExternal) {
                      <a [href]="item.link" class="footer-list-item" target="_blank" [rel]="item.rel"
                        >{{ item.text }} <app-svg src="/assets/icons/16/arrow-external.svg"></app-svg
                      ></a>
                    } @else {
                      <a [routerLink]="item.link" class="footer-list-item">{{ item.text }}</a>
                    }
                  }
                }
              </div>
            }
          </div>
        }
      }
      <div class="footer-bottom" [class.simple-mode]="simpleMode">
        <div class="footer-bottom-menu">
          <div class="footer-bottom-part">
            @if (!simpleMode) {
              <div class="badges">
                @if (tags$ | async; as tags) {
                  @for (tag of tags; track tag) {
                    <div class="badge">
                      <img
                        [src]="tag.icon.filename | storyblokCdn"
                        loading="lazy"
                        width="32"
                        height="32"
                        [alt]="tag.icon.alt"
                      />
                      <div class="badge-content">{{ tag.text }}</div>
                    </div>
                  }
                }
              </div>
            }

            <div class="footer-bottom-part-flex">
              <span class="copyright">© {{ currentYear }} Nusign AG</span>
              @if (legalLinks$ | async; as legalLinks) {
                @for (item of legalLinks; track item) {
                  <a [href]="item.link" class="footer-bottom-menu-item" target="_blank">{{ item.text }}</a>
                }
              }
            </div>
          </div>
          <div class="spacer"></div>

          <a class="footer-logo" *onlyForScreens="['desktop']" [routerLink]="['/']">
            @if (logo$ | async; as logo) {
              @if (!dark) {
                <img
                  [src]="logo.light.filename | storyblokCdn"
                  [alt]="logo.light.alt"
                  width="42"
                  height="42"
                  loading="lazy"
                />
              }
              @if (dark) {
                <img
                  [src]="logo.dark.filename | storyblokCdn"
                  [alt]="logo.dark.alt"
                  width="42"
                  height="42"
                  loading="lazy"
                />
              }
            }
          </a>

          <div class="spacer"></div>

          <div class="footer-bottom-part footer-bottom-part-flex">
            @if (socialIcons$ | async; as socialIcons) {
              @for (item of socialIcons; track item) {
                <a
                  [href]="item.link"
                  target="_blank"
                  appButton
                  name="DONTREPORT"
                  location="website-footer"
                  [iconButton]="true"
                  height="0"
                  color="hard-simple"
                  class="social-icon"
                  [attr.aria-label]="item.label"
                >
                  <app-svg [src]="item.icon.filename | storyblokCdn"></app-svg>
                </a>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
